import Cookies from 'js-cookie';

const getAuthToken = () => Cookies.get('accessToken') || Cookies.get('jwtToken');

export default function fetchWrapper(url, options = {}) {
  const authToken = getAuthToken();
  const isFormData = options.body instanceof FormData;
  const requestOptions = {
    method: options.method || 'GET',
    headers: {
      ...(isFormData ? {} : { 'Content-Type': 'application/json' }),
      ...(authToken && { Authorization: `Bearer ${authToken}` }),
      ...options.headers,
    },
    ...(options.body && {
      body: isFormData ? options.body : JSON.stringify(options.body),
    }),
  };

  return fetch(url, requestOptions).then(async (response) => {
    const contentType = response.headers.get('content-type');
    const isJson = contentType && contentType.includes('application/json');
    const json = isJson ? await response.json().catch(() => ({})) : {};
    if (response.ok) {
      return { status: response.status, ok: true, json };
    }
    if (response.status === 401 && Object.keys(json).length === 0) {
      const baseUrl = process.env.REACT_APP_BASE_URL || '';
      if (baseUrl) window.open(`${baseUrl}/session-expired`, '_self');
    }
    return Promise.reject({ status: response.status, ok: false, json });
  });
}
